import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import {
  Dashboard,
  AcademicSummary,
  SDashboard,
  PrintTranscript,
  LeaveSemester,
  Resignation,
  ThesisInfoSTD,
  ScoreViewIndex,
  ThesisActivitySTD,
  ThesisActivityExportPDF,
  MCurriculum,
  StdProfile
} from "../Page/Student";
import Profiles from "../Page/Profiles";
import ServiceRequest from "../Page/Widgets/ServiceRequest/ServiceRequest";
import {
  Leave,
  PCFRevisionCom,
  PlanCourseFormCom
} from "../Page/Student/Reregistration-New";
import { ThesisScoreIndex } from "../Page/Student/ScoreGrade/ThesisScore";

export function RouteStudent({ routers, student }) {
  const COMPONENT_MAP = {
    Dashboard: Dashboard,
    Profiles: Profiles,
    StdProfile: StdProfile,
    AcademicSummary: AcademicSummary,
    SDashboard: SDashboard,

    ScoreViewIndex: ScoreViewIndex,
    ThesisScoreIndex: ThesisScoreIndex,
    PrintTranscript: PrintTranscript,

    ServiceRequest: ServiceRequest,
    LeaveSemester: LeaveSemester,
    Resignation: Resignation,

    ThesisInfoSTD: ThesisInfoSTD,
    ThesisActivitySTD: ThesisActivitySTD,
    ThesisActivityExportPDF: ThesisActivityExportPDF,

    PlanCourseFormCom: PlanCourseFormCom,
    PCFRevisionCom: PCFRevisionCom,
    Leave: Leave,

    MCurriculum: MCurriculum
    // OLD
    // CurrPCF: CurrPCF,
    // RevisionPCF: RevisionPCF,
    // END OLD
  };
  const routeList = [];
  if (Object.keys(routers).length > 0) {
    for (let index = 0; index < routers.Academic.length; index++) {
      routeList.push(routers.Academic[index]);
    }
    for (let index = 0; index < routers.Config.length; index++) {
      routeList.push(routers.Config[index]);
    }
  }

  return (
    <Suspense fallback={<h3>Loading..</h3>}>
      <>
        <Route
          path="/"
          render={(routeProps) => (
            <COMPONENT_MAP.Dashboard {...routeProps} student={student} />
          )}
          exact />
        <Route
          path="/dashboard"
          render={(routeProps) => (
            <COMPONENT_MAP.Dashboard {...routeProps} student={student} />
          )} />
        <Route
          path="/profile"
          render={(routeProps) => (
            <COMPONENT_MAP.StdProfile {...routeProps} student={student} />
          )}
        />

        {/* NEW PCF RENDER - STAGING */}
        <Route
          path="/registration/revision-plan-course-form"
          component={COMPONENT_MAP["PCFRevisionCom"]}
        />
        <Route
          path="/curriculum"
          component={COMPONENT_MAP["MCurriculum"]}
        />

        {/* END  */}

        {/* ammar */}
        <Route path="/thesis/activity-export" component={COMPONENT_MAP["ThesisActivityExportPDF"]} />
        {/* end of ammar */}

        {Object.keys(routeList).length > 0
          ? routeList.map((v) =>
            Object.keys(v.Child).length > 0 ? (
              <Route
                key={v.ID}
                path={v.PathURI}
                render={({ match: { url } }) => (
                  <>
                    <Route
                      path={`${url}/`}
                      component={COMPONENT_MAP[v.Slug]}
                      exact
                    />
                    {v.Child.map((k) => (
                      <Route
                        key={v.ID}
                        path={`${url + k.URI}`}
                        component={COMPONENT_MAP[k.Slug]}
                      />
                    ))}
                  </>
                )}
              />
            ) : (
              <Route
                key={v.ID}
                path={v.PathURI}
                component={COMPONENT_MAP[v.Slug]}
              />
            )
          )
          : ""}
      </>
    </Suspense>
  );
}

export default RouteStudent;
